import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['label', 'feedback', 'source']

  copy(event) {
    event.preventDefault()
    event.stopPropagation()
    this.sourceTarget.classList.remove('hidden')
    this.sourceTarget.select()
    document.execCommand('copy')
    this.sourceTarget.classList.add('hidden')

    if (!this.hasFeedbackTarget) return
    this.labelTarget.classList.toggle('hidden')
    this.feedbackTarget.classList.toggle('hidden')

    setTimeout(() => {
      this.labelTarget.classList.toggle('hidden')
      this.feedbackTarget.classList.toggle('hidden')
    }, 4_000)
  }
}
